<div class="deletion-container">
  <h1 class="main-title">Request Profile Deletion</h1>

  <div class="warning-panel">
    <div class="warning-icon">
      <i class="fas fa-exclamation-triangle"></i>
    </div>
    <div class="warning-content">
      <h2>Warning: This Action Cannot Be Undone</h2>
      <p>Once your profile is deleted:</p>
      <ul>
        <li>All your personal data will be permanently removed</li>
        <li>You will lose access to all services and subscriptions</li>
        <li>Your username will be released for future use</li>
        <li>This process takes 30 days to complete</li>
      </ul>
    </div>
  </div>

  <form [formGroup]="deletionForm" (ngSubmit)="onSubmit()" class="deletion-form">
    <div class="confirmation-section">
      <div class="checkbox-group">
        <input type="checkbox" id="confirmDelete" formControlName="confirmDelete">
        <label for="confirmDelete">I understand this action permanently deletes my profile</label>
      </div>

      <div class="password-section">
        <label for="email">Enter your username:</label>
        <div class="password-input-group">
          <input [type]=" 'text' " id="email" name="email" formControlName="email"
            autocomplete="username" inputmode="email" autocapitalize="none"
            aria-label="Username or email" placeholder="Enter your username/email">
        </div>
        <div class="error-message" *ngIf="deletionForm.get('email')?.errors?.['required'] && deletionForm.get('email')?.touched">
          Email is required
        </div>
      </div>
      <div class="password-section">
        <label for="password">Enter your current password to confirm:</label>
        <div class="password-input-group">
          <input [type]="showPassword ? 'text' : 'password'" id="password" name="password" formControlName="password"
            autocomplete="current-password" aria-label="Password" placeholder="Enter your password">
          <button type="button" class="toggle-password" (click)="togglePassword()">
            <i class="fas" [class.fa-eye-slash]="showPassword" [class.fa-eye]="!showPassword"></i>
          </button>
        </div>
        <div class="error-message" *ngIf="deletionForm.get('password')?.errors?.['required'] && deletionForm.get('password')?.touched">
          Password is required
        </div>
        <div class="error-message" *ngIf="deletionForm.get('password')?.errors?.['minlength'] && deletionForm.get('password')?.touched">
          Password must be at least 8 characters
        </div>
      </div>
    </div>

    <div class="support-info">
      <p>Need help? Contact support at support&#64;example.com</p>
    </div>

    <button type="submit" class="btn btn-danger" [disabled]="!deletionForm.valid || isSubmitting">
      <span *ngIf="!isSubmitting">Permanently Delete My Profile</span>
      <div class="spinner" *ngIf="isSubmitting"></div>
    </button>
  </form>

  <div class="modal" *ngIf="showModal" [@fadeInOut]>
    <div class="modal-content">
      <h2>Final Confirmation</h2>
      <p>Are you absolutely sure you want to delete your profile?</p>
      <div class="modal-actions">
        <button class="btn btn-outline-dark" (click)="cancelDeletion()">Cancel</button>
        <button class="btn btn-danger" (click)="confirmDeletion()">Yes, Delete My Profile</button>
      </div>
    </div>
  </div>
</div>
